////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2026 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import {OptionsState} from "../states/OptionsState";
import {OptionsActions} from "../../Enums";

export function reducer(state: OptionsState, action: { type: OptionsActions, payload: any }): OptionsState {
  switch (action.type) {
    case OptionsActions.multipleActions:
      return {...state, ...action.payload};
    case OptionsActions.name:
      return {...state, name: action.payload};
    case OptionsActions.description:
      return {...state, description: action.payload};
    case OptionsActions.trigger:
      return {...state, trigger: action.payload};
    case OptionsActions.schedule:
      return {...state, schedule: action.payload};
    case OptionsActions.startDate:
      return {...state, startDate: action.payload};
    case OptionsActions.naming:
      return {...state, naming: action.payload};
    case OptionsActions.email:
      return {...state, email: action.payload};
    case OptionsActions.exportCsv:
      return {...state, exportCsv: action.payload};
    case OptionsActions.maintainFolderStructure:
      return {...state, maintainFolderStructure: action.payload};
    case OptionsActions.retainCloudModel:
      return {...state, retainCloudModel: action.payload};
    case OptionsActions.renameExisting:
      return {...state, renameExisting: action.payload};
    case OptionsActions.allowRecurring:
      return {...state, allowRecurring: action.payload};
  }
}